import { userInitialState } from './initial-state';
import { UserActions } from './action-creators';
import { UserState } from './state';
import * as actions from './actions';
import AdditionalAccount from '../../../../../common/types/data/additional-account';

const userReducer = (
  state: UserState = userInitialState,
  action: UserActions
): UserState => {
  switch (action.type) {
    case actions.SEARCH_USERS:
      return {
        ...state,
        search: {
          users: [],
          invites: [],
        },
      };

    case actions.UPDATE_USER_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          fullName: action.user.fullName,
          avatar: action.user.avatar,
          email: action.user.email || state.profile?.email,
          telephone: action.user.telephone || state.profile?.telephone,
          additionalEmails:
            action.user.additionalEmails || state.profile?.additionalEmails,
          additionalTelephones:
            action.user.additionalTelephones ||
            state.profile?.additionalTelephones,
        },
      };

    case actions.GET_USER_SUCCESS:
      return {
        ...state,
        profile: action.user,
      };

    case actions.SEARCH_USERS_SUCCESS:
      return {
        ...state,
        search: {
          users: action.users,
          invites: action.invites,
        },
      };

    case actions.RESET_USER_STORE:
      return { ...userInitialState };

    case actions.ADD_NEW_ACCOUNT: {
      return {
        ...state,
        newAccount: action.account,
      };
    }

    case actions.CREATE_ADDITIONAL_ACCOUNT_SUCCESS: {
      const key =
        'attribute' in action.account
          ? state.newAccount?.type === 'email'
            ? 'email'
            : 'telephone'
          : state.newAccount?.type === 'email'
          ? 'additionalEmails'
          : 'additionalTelephones';

      const value =
        'attribute' in action.account
          ? state.newAccount?.address || ''
          : [
              ...((state.profile?.[key] as AdditionalAccount[]) || []),
              action.account,
            ];

      return {
        ...state,
        newAccount: undefined,
        profile: {
          ...state.profile,
          [key]: value,
        },
      };
    }

    case actions.DELETE_ADDITIONAL_ACCOUNT_SUCCESS: {
      return {
        ...state,
        profile: {
          ...state.profile,
          additionalEmails: state.profile?.additionalEmails?.filter(
            (a) => a.value !== action.account.value
          ),
          additionalTelephones: state.profile?.additionalTelephones?.filter(
            (a) => a.value !== action.account.value
          ),
        },
      };
    }

    case actions.MARK_AS_VERIFIED: {
      return {
        ...state,
        profile: {
          ...state.profile,
          additionalEmails: (state.profile?.additionalEmails || []).map(
            (a) => ({
              ...a,
              verified: action.address === a.value || a.verified,
            })
          ),
          additionalTelephones: (state.profile?.additionalTelephones || []).map(
            (a) => ({
              ...a,
              verified: action.address === a.value || a.verified,
            })
          ),
        },
      };
    }

    default:
      return state;
  }
};

export default userReducer;
